import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Projects from "./Projects";
import UserProfile from "./UserProfile";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function LandingPage() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("dashboard");
  const [languages, setLanguages] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/login");
    }
  }, [navigate]);
  
  const fetchLanguages = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/languages`);
      setLanguages(response.data);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  const fetchProjects = async () => {
    const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
    try {
      const response = await axios.get(`${BACKEND_URL}/projects?user_id=${userId}`);
      setProjects(response.data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const handleDelete = (deletedId) => {
    setProjects(prev => prev.filter(p => p.OCAIAPP_ProjectsId !== deletedId));
  };

  useEffect(() => {
    fetchLanguages();
    fetchProjects();
  }, []);

  return (
    <div className="dashboard-root">
      <div className="dashboard-topbar">
        <span className="dashboard-title">Dashboard</span>
      </div>

      {/* Sidebar */}
      <div className="dashboard-sidebar">
        <div className="dashboard-logo">
          <span className="logo-text">HtD</span>
        </div>
        <nav className="dashboard-nav">
          <button onClick={() => navigate("/main")}>Creëer nieuw project</button>
          <button onClick={() => setActivePage("dashboard")}>Projecten</button>
          <button onClick={() => setActivePage("profile")}>Profiel</button>
        </nav>
        <div className="dashboard-language">
          <label>Taal:</label>
          <select>
            {languages.map((lang, idx) => (
              <option key={idx} value={lang.OCAIAPP_Lang_Name}>
                {lang.OCAIAPP_Lang_Name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="dashboard-content">
        {activePage === "dashboard" && <Projects projects={projects} onDelete={handleDelete} BACKEND_URL={BACKEND_URL}/>}
        {activePage === "profile" && <UserProfile />}
      </div>
      <div className="dashboard-new-project" onClick={() => navigate("/main")}>Nieuw project +</div>
    </div>
  );
}